import column from './column';
import line from './line';

export default {
  column,
  line,
};
